module.exports = __webpack_public_path__ + "iphone-border.5b891b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/DeveloperIntegration/iFrame/iphone-border.png
// module id = 1421
// module chunks = 0